import { map, pipe } from '@fxts/core';

// 1. valueSelector 없을 때 (전체 객체 반환)
export function createMap<T, K extends keyof T>(
  items: readonly T[],
  key: K,
): { [P in T[K] & PropertyKey]: T };

// 2. valueSelector가 키일 때 (특정 필드 반환)
export function createMap<T, K extends keyof T, V extends keyof T>(
  items: readonly T[],
  key: K,
  valueSelector: V,
): { [P in T[K] & PropertyKey]: T[V] };

// 3. valueSelector가 함수일 때 (커스텀 값 반환)
export function createMap<T, K extends keyof T, V>(
  items: readonly T[],
  key: K,
  valueSelector: (item: T) => V,
): { [P in T[K] & PropertyKey]: V };

export function createMap<T, K extends keyof T, V>(
  items: readonly T[],
  key: K,
  valueSelector?: ((item: T) => V) | keyof T,
) {
  return pipe(
    items,
    map(
      (item) =>
        [
          item[key],
          valueSelector
            ? typeof valueSelector === 'function'
              ? valueSelector(item)
              : item[valueSelector]
            : item,
        ] as const,
    ),
    (entries) => Object.fromEntries(entries),
  );
}
